export const gitCommit = '9d9119dc'
